<script>
import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";

import Nav from '@/components/Nav'

import { weTeachHelper } from "@/helpers/weTeachHelper";
import { onboardingHelper } from "@/helpers/onboardingHelper";

import EventBus from "@/event-bus";

import store from '@/store'

@Component({
  components: {
    Nav
  },
  computed: {
    ...mapGetters({
      userRole: "getUserRole"
    }),
    steps() {
      let steps = weTeachHelper().steps;
      if (this.userRole === "Teacher") {
        steps.unshift(weTeachHelper().teacherStepOne);
      } else {
        steps.unshift(weTeachHelper().adminStepOne);
      }
      return steps;
    }
  }
})
export default class WeTeach extends Vue {
    weTeachLogo = weTeachHelper().weTeachLogo
    arrow = weTeachHelper().arrow 
    rows = weTeachHelper().rows
    columns = weTeachHelper().columns
    loading = false
    
    created() {
      store.commit('currentPage', 'weTeach')
    }
    mounted() {
        EventBus.$on('start intro', () => {
            this.startIntro()
        })
        EventBus.$on('loading', () => {
            this.loading = true
        })
        
        this.$nextTick(() => {
            if (localStorage.getItem('doneWeTeachOnboarding')) {
                return
            } else {
                this.startIntro();
            }
        })
    }
    
    startIntro() {
        onboardingHelper().startIntro(
            introJs(), this, 'doneWeTeachOnboarding'
        )
    }
}
</script>

<template>
  <div
    class="weteach-container"
    v-loading="loading"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Loading..."
  >
    <div class="weteach-heading flex">
      <div class="weteach-heading-img">
        <img :src="weTeachLogo" alt="we teach nyc logo" />
      </div>
      <div class="weteach-heading-text">
        <p>
          <a target="_blank" href="https://www.weteachnyc.org/" id="weteach-link">WeTeachNYC</a> is an online professional learning space for teachers and school leaders.
          <br />Below are summaries of just a few of the articles you can find on WeTeachNYC.
        </p>
      </div>
    </div>

    <div class="weteach-content">
      <div v-for="item in rows" :key="item.rows" class="weteach-content-row">
        <div class="flex" :class="{ 'flex-reverse': item.reverse }">
          <div class="weteach-content-image">
            <img
              :class="item.heading === 'teacher self-reflection tool' ? 'margin-top' : null"
              :src="item.imageUrl"
            />
          </div>

          <div class="weteach-content-text">
            <h2>{{ item.heading }}</h2>
            <p>{{ item.text }}</p>
            <p>
              <a target="_blank" :href="item.link">
                Read More on WeTeachNYC
                <img class="arrow" :src="arrow" alt="arrow" />
              </a>
            </p>
          </div>
        </div>

        <hr :class="item.heading === 'danielson framework for teaching' ? 'hr-width' : null" />
      </div>

      <div class="flex">
        <div v-for="item in columns" :key="item.columns" class="weteach-content-column">
          <h2>{{ item.heading }}</h2>
          <p>{{ item.text }}</p>
          <p>
            <a target="_blank" :href="item.link">
              Read More on WeTeachNYC
              <img class="arrow" :src="arrow" alt="arrow" />
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.weteach-container {
  max-width: 1200px;
  margin: 25px auto;
  padding: 25px;
  h2 {
    text-transform: uppercase;
    font-weight: normal;
  }
  .hr-width {
    max-width: 60%;
    margin: 0;
  }
  .weteach-heading {
    .weteach-heading-img img {
      width: 167px;
      margin-right: 30px;
    }
    .weteach-heading-text p {
      font-size: 24px;
      margin: 5px auto;
      line-height: 1.46;
    }
  }
  .weteach-content {
    margin-top: 50px;
  }
  .weteach-content-row {
    .flex {
      margin: 30px auto;
      div {
        flex-basis: 50%;
      }
      &.flex-reverse {
        justify-content: space-between;
        margin: 30px auto 15px;
      }
      .weteach-content-image:nth-child(2) {
        flex-basis: 40%;
      }
      .margin-top {
        margin-top: -100px;
      }
      &.flex-reverse .weteach-content-image {
        text-align: right;
      }
      h2 {
        margin-top: 0;
      }
      p {
        width: 720px;
      }
    }
  }
  .weteach-content-row,
  .weteach-content-column {
    p {
      font-size: 18px;
      line-height: 1.4;
      text-align: justify;
    }
    a {
      text-decoration: none;
      color: #9b9b9b;
      font-family: "museo_slab", sans-serif;
    }
    .arrow {
      margin-left: 15px;
    }
  }
  .weteach-content-column:first-child {
    margin-right: 40px;
  }
  @supports (-ms-ime-align: auto) {
    .weteach-container .weteach-content-row .hr-width {
      max-width: 725px;
      text-align: left;
    }
  }
}
</style>